<!-- eslint-disable -->
<template lang="pug">
    div.game-preview-settings
        slot
</template>

<script>
    /*eslint-disable*/
    export default {}
</script>

<style lang="scss" scoped>
    .game-preview-settings {
        @include stack-space($space-base);
    }
</style>
